import React, { memo } from 'react';

import TrackList, { TrackListGroup } from '../trackList/TrackList';

type TracklistContentProps = { content: Array<TrackListGroup> };

const TracklistContent = memo(
  ({ content }: TracklistContentProps): JSX.Element => <TrackList trackListGroups={content} />
);

export default TracklistContent;
